<ng-container *transloco="let t">
  <td iTableTd>
    <div class="flex w-max items-center gap-2">
      @if (!isReadOnly()) {
        <ICheckbox [(value)]="isRowSelected" class="mr-1.5" />
      }
      <img [src]="product().imageUrl" alt="" class="size-7 rounded-md border border-gray-200" />

      <a
        iButton
        size="sm"
        variant="ghost"
        [href]="product().asin! | amazonAsinUrlPipe: accountMarketplace()!.marketplace"
        target="_blank"
        class="group"
        [iTooltip]="t('catalog-page.view_product_in_amazon')"
        iTooltipPlacement="right-center"
        >{{ product().asin }}
        <IIcon name="arrowUpRight" class="opacity-0 group-hover:opacity-100" />
      </a>
    </div>
  </td>
  <td iTableTd class="w-full max-w-0 cursor-default truncate" tooltipTruncated>
    {{ product().title }}
  </td>
  <td iTableTd>
    <span class="text-xs text-gray-500">{{ product().brand }}</span>
  </td>
  <td iTableTd>
    <div class="text-right text-gray-500">
      @let strategiesLength = product().strategies?.length ?? 0;
      <button
        iButton
        size="sm"
        [iTooltip]="
          strategiesLength > 0
            ? t('catalog-row.number_of_active_strategies_with_asin', { asin: product().asin })
            : t('catalog-row.no_active_strategies')
        "
        [disabled]="strategiesLength === 0"
        variant="ghost"
        (click)="openStrategiesModal()"
      >
        {{ strategiesLength }}
      </button>
    </div>
  </td>
  @if (isManaged()) {
    <td iTableTd>
      <div class="text-right text-gray-800">
        <button iButton size="sm" variant="ghost" [disabled]="!!isReadOnly()" (click)="editCogs(product())">
          {{ formattedCogs() }}
        </button>
      </div>
    </td>

    <td iTableTd>
      <div class="text-right text-gray-800">
        <button
          iButton
          size="sm"
          variant="ghost"
          [iTooltip]="seedsTooltip() ?? undefined"
          [disabled]="isSeedsDisabled()"
          (click)="openSeedsEditionModal(true)"
        >
          {{ seedsLength() > 0 ? seedsLength().toString() : "-" }}
        </button>
      </div>
    </td>
    <td iTableTd>
      <div class="text-right text-gray-800">
        <button
          iButton
          size="sm"
          variant="ghost"
          [iTooltip]="blacklistTooltip() ?? undefined"
          [disabled]="isSeedsDisabled()"
          (click)="openSeedsEditionModal(false)"
        >
          {{ blacklistLength() > 0 ? blacklistLength().toString() : "-" }}
        </button>
      </div>
    </td>

    <td iTableTd class="group">
      <span class="text-gray-500"
        ><button iButton size="sm" variant="ghost" (click)="editProductTag(ProductTagField.FIELD1)">
          {{ product().productTag1 ?? "-" }}
        </button></span
      >
    </td>
    <td iTableTd>
      <span class="text-gray-500"
        ><button iButton size="sm" variant="ghost" (click)="editProductTag(ProductTagField.FIELD2)">
          {{ product().productTag2 ?? "-" }}
        </button></span
      >
    </td>
  }
</ng-container>
